import { useQuery } from '@tanstack/react-query';
import { financialApi } from '../api/financialApi';

export const useFinancialOverview = (range: number) => {
  return useQuery({
    queryKey: ['financial-overview', range],
    queryFn: () => financialApi.getOverview(range),
  });
};
